export default __webpack_public_path__ + "static/media/sharples_thumb500px.00f47d6e.jpg";